import React, { useEffect, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { ExamSearch } from '../../components/Exam/ExamSearch';
import { GetTestDto } from '../../../common/spdCore/autogenerated/spdApiClient';

type ParamTypes = {
  testId: string;
};

export const ExamsByTestView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const [test, setTest] = useState<GetTestDto>();

  const { testId } = useParams<ParamTypes>() as {
    testId: string;
  };

  useEffect(() => {
    spd.tests
      .getTest(testId)
      .then(test => setTest(test))
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem testu. ${error}`),
      );
  }, [testId, spd.tests]);

  const handleClick = async (id: string) => {
    void nav.examTests(id);
  };

  const getData = async (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => {
    return spd.exams.getAllByTestByPortion(
      testId,
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    );
  };

  const getCount = async (filterText?: string, filterColumns?: string) => {
    return spd.exams.getAllByTestCount(testId, filterText, filterColumns);
  };

  const getCompletedData = async (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => {
    return spd.exams.getAllByTestByPortion(
      testId,
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
      true,
    );
  };

  const getCompletedCount = async (
    filterText?: string,
    filterColumns?: string,
  ) => {
    return spd.exams.getAllByTestCount(testId, filterText, filterColumns, true);
  };

  return (
    <Card>
      <Tabs defaultActiveKey={'examsByTest'} id="exams" className="mb-3">
        <Tab
          eventKey="examsByTest"
          title={`Wszystkie badania z testem: ${test?.name || ''}`}
          className="m-3"
        >
          <ExamSearch
            getData={getData}
            getCount={getCount}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="completedExamsByTest" title="Zakończone" className="m-3">
          <ExamSearch
            getData={getCompletedData}
            getCount={getCompletedCount}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
